import Api from '@/api/stock/api_stock.js'

// STOCK-LABO SL-2 : le laboratoire lit son stock et déclare ses consommations directement sur be_stock
// (même instance que les médicaments de l'ordonnance : jeton be_config en en-tête).
export default {
    /** Tous les stocks (repli quand la route par code n'est pas déployée). */
    stocks() {
        return Api().get('/stocks').then((response) => response.data)
    },

    /** Un stock par son code technique (« laboratoire »). */
    stockParCode(code) {
        return Api().get('/stocks/code/' + code).then((response) => response.data)
    },

    /** Articles (quantité, seuil), entrées et sorties d'un stock. */
    stock(id) {
        return Api().get('/stock/' + id).then((response) => response.data)
    },

    /** Historique authentifié et limité à l'armoire accessible à l'utilisateur. */
    articleHistory(stockId, articleId, direction, page = 1) {
        return Api().get('/v1/service-stocks/' + stockId + '/articles/' + articleId + '/history', {
            params: { direction, page }
        }).then((response) => response.data)
    },

    /** Transferts reçus (type 1) et envoyés (type 0) d'un stock. */
    echanges(id) {
        return Api().get('/echanges/' + id).then((response) => response.data)
    },

    /** Sortie de stock : { stock, article, nombre, motif, user_id } → { sortie: true|false }. */
    sortie(data) {
        return Api().post('/sortie', data).then((response) => response.data)
    },

    /** Réactifs suivis au flacon : réglages des articles, flacons en cours et terminés. */
    flacons() {
        return Api().get('/v1/laboratoire/flacons').then((response) => response.data)
    },

    /** Ouvrir un flacon : { article_id, lot, date_peremption, stabilite_jours, cq_fait, request_key, fuseau }. */
    ouvrirFlacon(data) {
        return Api().post('/v1/laboratoire/flacons', data).then((response) => response.data)
    },

    /** Terminer un flacon : { motif_fin: epuise|perime|jete|cq_non_conforme, commentaire }. */
    terminerFlacon(id, data) {
        return Api().post('/v1/laboratoire/flacons/' + id + '/terminer', data).then((response) => response.data)
    },

    controleQualiteFlacon(id, cq_fait) {
        return Api().post('/v1/laboratoire/flacons/' + id + '/controle-qualite', { cq_fait }).then((response) => response.data)
    },

    /** Réglages de l'article : { suivi: flacon|unite|null, stabilite_jours }. */
    reglerSuivi(article_id, data) {
        return Api().put('/v1/laboratoire/articles/' + article_id + '/suivi', data).then((response) => response.data)
    },
}
